<template>
	<div id="charge-result" v-if="resultShow">
		<h2>{{$t('charge.SuccessTip')}}</h2>
		<b>{{$t('charge.OrderInformation')}}</b>
		<span><i>{{$t('charge.RechargeAccount')}}</i>{{displayAccount}}</span>
		<span><i>{{$t('charge.TopupGame')}}</i>{{game?game.name[$i18n.locale]:''}}</span>
		<span><i>{{$t('charge.Rechargeserver')}}</i>{{region?region.name:''}}</span>
		<span><i>{{$t('charge.Provider')}}</i>{{payment?payment.name:''}}</span>
		<span v-if="pay_methods.length>0"><i>{{$t('charge.Paymentmethod')}}</i>{{pay_methods[methodIndex].name}}</span>
		<span><i>{{$t('charge.TotalrechargeAmount')}}</i>{{$t('charge.GoldAmount',{gold:chargeResult.gold})}}<em>({{chargeResult.currency}} {{chargeResult.amount/100}})</em></span>
		<div style="margin-top: 20px">
			<wd-button :bordered="true" size="medium" @click.native="resultShow = false" :styles="{marginRight:'10px'}">{{$t('charge.Topupagain')}}</wd-button> 
			<wd-button :bordered="true" size="medium" to="recahrgeHistory">{{$t('charge.RechargeHistory')}}</wd-button>
		</div>
	</div>
	<div id="charge" v-else>
		<div class="payments">
			<a href="javascript:;" :class="chosedPayment == payment.id ? 'active' : ''" v-for="(payment,idx) in payments" :key="'payment-'+idx" @click="chosePayment(payment)" v-if="isLan(payment.languages)">
				<img :src="payment.logo" alt="" v-if="payment.logo">
				<span v-else>{{payment.name}}</span>
			</a>
		</div>
		<div class="charge-container">
			<div class="step-div">
				<i class="step-num"></i>
				<b>{{$t('charge.RechargeAccount')}}：{{displayAccount}}</b>
				<div class="game-region">
					<select name="game_id" v-model="game_id" @change="region_id=0;rules=[],currentIndex=-1">
						<option :value="0">{{$t('charge.ChoseGame')}}</option>
						<option :value="game.id" v-for="(game,idx) in filterGames" v-if="isLan(game.languages)" :key="'g-opt-'+idx">{{game.name[$i18n.locale]}}</option>
					</select>
					<select name="region_id" v-model="region_id" @change="getRules">
						<option :value="0">{{$t('charge.ChoseServer')}}</option>
						<option :value="region.id" v-for="(region,idx) in regions" v-if="isLan(region.languages)" :key="'r-opt-'+idx">{{region.name}}</option>
					</select>
				</div>
			</div>
			
			<div class="step-div">
				<i class="step-num"></i>
				<b>{{$t('charge.RechargeAmount')}}</b>
				<div class="amount-div">
					<span :class="idx == currentIndex?'active':''" @click="selectGold(item,idx)" v-for="(item,idx) in choseGolds" :key="'amount-'+idx">{{item.name?item.name:$t('charge.GoldAmount',{gold:item.gold})}}</span>
					<div>
					<p style="font-size: 14px; margin-top: 10px; color: #666; margin-bottom: 10px" v-if="amountCustom">{{$t('charge.TenAmount')}}：</p>
					<span :class="isCustomeGold?'active':''" style="width: 240px" v-if="amountCustom"><input type="number" :placeholder="$t('charge.AmountTip')" @blur="setGold" style="width: 200px;"></span>
					</div>
				</div>
			</div>
			<div class="step-div" v-if="pay_methods.length>0">
				<i class="step-num"></i>
				<b>{{$t('charge.Paymentmethod')}}</b>
				<div class="amount-div">
					<span :class="idx == methodIndex?'active':''" @click="selectMethod(item,idx)"  v-for="(item,idx) in pay_methods" :key="'method-'+idx">{{item.name}}</span>
				</div>
			</div>
			
			<div class="step-div">
				<i class="step-num"></i>
				<b>{{$t('charge.Overview')}}</b>
				<table cellpadding="0" cellspacing="0">
					<tr>
						<th width="16.6%">{{$t('charge.Game')}}</th>
						<th width="16.6%">{{$t('charge.Server')}}</th>
						<th width="16.6%">{{$t('charge.Provider')}}</th>
						<th width="16.6%" v-if="pay_methods.length>0">{{$t('charge.Paymentmethod')}}</th>
						<th width="16.6%">{{$t('charge.RechargeAmount')}}</th>
						<th width="16.6%">{{$t('charge.Price')}}</th>
					</tr>
					<tr>
						<td>{{game?game.name[$i18n.locale]:'-'}}</td>
						<td>{{region?region.name:'-'}}</td>
						<td>{{payment?payment.name:'-'}}</td>
						<td v-if="pay_methods.length>0">{{pay_methods[methodIndex].name}}</td>
						<td>
							<span v-if="gold>0">{{$t('charge.GoldAmount',{gold:gold})}}</span>
							<span v-else>-</span>
						</td>
						<td>
							{{getChargeAmount()}}
						</td>
					</tr>
				</table>
			</div>
			<div class="step-div" v-if="currentLanguage == 'en'">
				<label style="font-size:14px"><input type="checkbox" v-model="checked"/>Agree to <a href="https://fbhk.wan5d.com/Service.html" target="_blank" style="color:#409eff">Terms of Service</a></label>
			</div>
			<div class="step-div">
				<wd-button type="danger" size="large" @click.native="chargeSubmit">{{$t('charge.Confirmthepayment')}}</wd-button>
			</div>
		</div>

		<div v-show="payForm == 1" class="dialog-bg">
			<div class="dialog-container" style="text-align: center;">
				<h2>{{$t('charge.ConfirmThePayment')}}</h2>
				<a href="javascript:;" class="dialog-close-btn" @click="payForm = 0"></a>
				<table cellspacing="0" cellpadding="0" style="margin: 0px auto">
					<tr>
						<td>{{$t('chargeHistory.GameServer')}}</td>
						<td>{{game?game.name[$i18n.locale]:'-'}} {{region?region.name:'-'}}</td>
					</tr>
					<tr>
						<td>{{$t('charge.RechargeAmount')}}</td>
						<td>{{$t('charge.GoldAmount',{gold:gold})}}</td>
					</tr>
					<tr>
						<td>{{$t('charge.Price')}}</td>
						<td>{{getChargeAmount()}}</td>
					</tr>
					<tr>
						<td>{{$t('charge.Provider')}}</td>
						<td>{{payment?payment.name:''}}</td>
					</tr>
					<tr v-if="pay_methods.length>0">
						<td>{{$t('charge.Paymentmethod')}}</td>
						<td>{{pay_methods[methodIndex].name}}</td>
					</tr>
				</table>
				<div style="margin-top: 20px;">
					<div v-if="chosedPayment == 2">
						<div>{{$t('charge.PayWithWeixin')}}</div>
						<canvas id="wx-qrcode"></canvas>
					</div>
					<!-- pagseguro支付方式表单提交，执行pagseguro方法-->
					<a href="javascript:;" @click="pagseguro" class="confirm-btn" v-else-if="!hasClickPayLink && chosedPayment == 6">{{$t('charge.Confirmthepayment')}}</a>
					<a :href="payResult.paylink || ''" @click="hasClickPayLink=true" target="_blank" class="confirm-btn" v-else-if="!hasClickPayLink">{{$t('charge.Confirmthepayment')}}</a>
					<div v-if="chosedPayment == 2 || hasClickPayLink">
						<wd-button :bordered="false" type="danger" size="medium" @click.native="getPayResult" :styles="{marginRight:'10px'}">{{$t('charge.TopupSuccessfully')}}</wd-button> 
						<a :href="'http://www.wooduan.com/service?lang='+($i18n.locale=='zh'?'zh':'en')" style="background-color: #ddd;font-size: 16px;border-radius: 4px;padding: 8px 12px;" target="_blank">{{$t('charge.TopupProblems')}}</a>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>
<script>
	import WdButton from '@/components/WdButton.vue';
	import QRCode from 'qrcode';
	export default{
		name:"",
		components:{
			'wd-button':WdButton
		},
		data(){
			return {
				hasClickPayLink:false,
				payForm:0,
				resultShow:false,
				rules:[],
				payments:[],
				games:[],
				chosedPayment:0,
				account:'',
				nick:'',
				email:'',
				phone:'',
				game_id:0,
				region_id:0,
				bank_id:0,
				gold:0,
				payResult:{},
				chargeResult:{},
				currentIndex:-1,
				methodIndex:0,//支付渠道及其索引
				pay_methods:[],
				payssion_pay_methods:[],//payssion方式下的支付渠道
				loading:false,
				checked:true,//英文状态下是否勾选协议
			}
		},
		watch:{
			currentLanguage(){
				if(this.resultShow == true) return;
				this.game_id = 0;
				this.region_id = 0;
				this.gold = 0;
				this.bank_id = 0;
				this.pay_methods = [];
				this.choseFirstPayment();
			},
		},
		computed: {
			displayAccount(){
				if(this.email) return this.email;
				if(this.phone) return this.phone;
				return this.account;
			},
			payment(){
				let pmt = null;
				for (var i = 0; i < this.payments.length; i++) {
					if(this.payments[i].languages.indexOf(this.$i18n.locale) < 0) continue;
	        		if(this.payments[i].id == this.chosedPayment) pmt = this.payments[i];
	        	}
	        	if(!pmt){
	        		for (var i = this.payments.length - 1; i >= 0; i--) {
						if(this.payments[i].languages.indexOf(this.$i18n.locale)>-1){
							this.chosedPayment = this.payments[i].id;
							pmt = this.payments[i];
							break;
						}
					}
	        	}
	        	return pmt;
			},
	        regions(){
	        	for (var i = 0; i < this.games.length; i++) {
	        		if(this.games[i].id == this.game_id) return this.games[i].regions;
	        	}
	        },
	        game(){
	        	for (var i = 0; i < this.games.length; i++) {
	        		if(this.games[i].id == this.game_id) return this.games[i];
	        	}
	        	return null
	        },
	        region(){
	        	for (var i = 0; i < this.games.length; i++) {
	        		if(this.games[i].id == this.game_id){
	        			for (var j = 0; j< this.games[i].regions.length; j++) {
	        				if(this.games[i].regions[j].id == this.region_id){
	        					return this.games[i].regions[j];
	        				}
	        			}
	        		}
	        	}
	        	return null;
	        },
	        isCustomeGold(){
	        	if(this.choseGolds.indexOf(parseInt(this.gold))>-1){
					return false;
				}
				if(this.gold <= 0) return false;
				return true;
	        },
	        currentLanguage(){
	        	return this.$i18n.locale;
	        },
	        choseGolds(){
				if(this.game_id && this.region_id){
	        		let golds = this.rules;
	        		if(golds.length>0) return golds;
	        		return [];
	        	}
				return [];
	        },
	        amountRatio(){
	        	if(this.game_id && this.game.pay_configs[this.currentLanguage]){
	        		return this.game.pay_configs[this.currentLanguage].ratio;
	        	}
	        	return 1;
	        },
	        amountCurrency(){//根据游戏选择默认币种
	        	if(this.game_id && this.game.pay_configs[this.currentLanguage]){
	        		return this.game.pay_configs[this.currentLanguage].currency;
	        	}
	        	return '';
	        },
	        amountCustom(){
	        	if(this.game_id && this.game.pay_configs[this.currentLanguage]){
	        		return this.game.pay_configs[this.currentLanguage].custom;
	        	}
	        	return false;
			},
			filterGames(){
				// if(this.games.length>2){
				// 	if(this.currentLanguage == 'zh'){
				// 		return [this.games[2]];
				// 	}else if(this.currentLanguage == 'en'){
				// 		return [this.games[2]];
				// 	}else if(this.currentLanguage == 'tr'){
				// 		return [this.games[1]];
				// 	}else if(this.currentLanguage == 'tw'){
				// 		return this.games;
				// 	}
				// }else{
				// 	return this.games;
				// }
				return this.games;	
			},
	    },
		methods:{
			isLan(arr){
				if(arr.length<1) return true;
				if(arr.indexOf(this.$i18n.locale)>-1) return true;
				return false;
			},
			choseFirstPayment(){
				for (var i = 0; i<this.payments.length;i++) {
					if(this.payments[i].languages.indexOf(this.currentLanguage)>-1){
						this.chosedPayment = this.payments[i].id;
						break;
					}
				}
			},
			chosePayment(payment){
				this.chosedPayment = payment.id;
				this.game_id = 0;
				this.region_id = 0;
				this.gold = 0;
				this.methodIndex = 0;
				this.pay_methods = [];
				if(payment.id == 3) this.getPayssionChannel();//获取payssion方式下的支付渠道
			},
			setGold(event){
				let val = Math.abs(parseInt(event.target.value))
				val = Math.floor(val/10)*10;
				event.target.value = val;
				this.gold = val
			},
			async chargeSubmit(){
				if(this.loading) return;

				if(!this.game_id || !this.region_id){
					this.$alert(this.$t('charge.ChoseGameAndRegion'));
					return;
				}
				if(this.gold<1){
					this.$alert(this.$t('charge.ChoseAmount'));
					return;
				}
				if(this.chosedPayment<1){
					this.$alert(this.$t('charge.ChoseChargeType'));
					return;
				}
				if(this.currentLanguage == 'en' && !this.checked){
					return this.$alert(this.$t('charge.Terms'));
				}
				this.loading = true;
				let ca = this.getChargeAmount(true);
				let postData = {
					game_id:this.game_id,
					region_id:this.region_id,
					payment_id:this.chosedPayment,
					amount:ca.amount,
					currency:ca.currency,
					gold:this.gold,
					language:this.$i18n.locale,
					rule_id:this.rule_id,
					payment_channel:this.pay_methods.length>0?this.pay_methods[this.methodIndex].value:'',
					from: this.from,
				}

				let response = await this.$api.post('/web/index/createChargeBill',postData);
				if(response.code == 0){
					this.payResult = response.data
					this.payForm = 1
					this.hasClickPayLink = false;
					if(this.chosedPayment == 2){//微信
						var qrcode= document.getElementById('wx-qrcode')
			              // 将获取到的数据（val）画到msg（canvas）上
			            QRCode.toCanvas(qrcode, response.data.code_url, function (error) {
			                    console.log(error)
			            })
					}
				}else if(response.code == 450010) {
					this.$alert(response.msg);
				}else{
					this.$alert(this.$t('charge.TopupFailTip'));
				}
				this.loading = false;
			},
			// pagseguro支付方式表单提交
			pagseguro(){    
				this.hasClickPayLink = true;
				let path = this.payResult.paylink;
				let params = this.payResult.pay_params;

                var form = document.createElement("form");
                form.setAttribute("method", "post");
				form.setAttribute("action", path);
				form.setAttribute("target",'_blank');
                for(var key in params) {
                    if(params.hasOwnProperty(key)) {
                        var hiddenField = document.createElement("input");
                        hiddenField.setAttribute("type", "hidden");
                        hiddenField.setAttribute("name", key);
                        hiddenField.setAttribute("value", params[key]);
                        form.appendChild(hiddenField);
                    }
                }
				document.body.appendChild(form);
                form.submit(); 
			},

			async getPayResult(){
				let order_no = this.payResult ? this.payResult.order_no : '';
				if(this.$route.query.out_trade_no) order_no = this.$route.query.out_trade_no;
				if(this.$route.query.order_id) order_no = this.$route.query.order_id;
				// 充值失败
				let err_msg='';
				if(this.$route.query.err_msg) err_msg = decodeURI(this.$route.query.err_msg);
				if(order_no){
					let payResult = await this.$api.post('/web/index/saveChargeOrder',{order_no});
					if(payResult.code == 0){
						this.payForm = 0;
						this.resultShow = true;
						this.hasClickPayLink = false;
						if(this.$i18n) this.$i18n.locale = payResult.data.language;
						this.game_id = payResult.data.game_id;
						this.region_id = payResult.data.region_id;
						this.chosedPayment = payResult.data.payment_id;
						this.chargeResult = payResult.data;
						await this.getRules();
					}else{
						if(this.$route.query.err_msg){
							this.$alert(err_msg)
						}else{
							if(payResult.msg){
								this.$alert(this.$t('charge.TopupFailNeedService',{msg:'['+payResult.msg+']'}));
							}else{
								this.$alert(this.$t('charge.TopupFailNeedService',{msg:''}));
							}
						}
					}
				}
			},

			async getRules(){
				let data = {
					game_id:this.game_id,
					region_id:this.region_id,
					language:this.currentLanguage
				}
				this.gold = 0;
				this.currentIndex = -1;
				let response = await this.$api.get('/web/index/getChargeRules',data);
				if(response.code == 0){
					this.rules = response.data.rules;
				}
			},
			getChargeAmount(type){
				if(!this.game_id || !this.region_id) return '-';
				let amount = 0;
				let currency = this.amountCurrency;
				for (var i = this.rules.length - 1; i >= 0; i--) {
					if(this.rules[i].gold == this.gold){
						amount = this.rules[i].amount / 100;
						if(this.rules[i].currency) currency = this.rules[i].currency;
					}
				}
				if(!amount) amount = this.gold * this.amountRatio / 100;
				if(type){
					return {
						amount:amount * 100,
						currency:currency
					};
				}
				if(!amount) return '-';
				if(this.currentLanguage == 'zh'){
					return amount.toFixed(2) + ' '+ this.$t('default.'+currency);
				}else{
					return currency +' '+ amount.toFixed(2)
				}
				this.amountCurrency = currency;
			},
			selectGold(item,i){
				this.gold = item.gold?item.gold:0;
				this.rule_id = item.id?item.id:0;
				this.currentIndex = i;
				// 获取支付渠道
				this.pay_methods = Object.keys(this.payment.pay_methods).length>0?this.payment.pay_methods[this.amountCurrency]:[];
				if(this.chosedPayment == 3 && this.payssion_pay_methods.length>0){
					this.pay_methods = this.payssion_pay_methods
				}	
			},
			selectMethod(item,i){
				this.methodIndex = i
			},
			async getPayssionChannel(){// payssion开通美洲其他国家地区支付
				let {code,data} = await this.$api.get('/web/index/getPayssionChannel')
				if(code == 0){
					this.payssion_pay_methods = data.list;
				}
			}
		},
		async created(){
			
			let user = await this.$getUser();
			if(user){
				this.nick = user.nick;
				this.email = user.email;
				this.phone = user.phone;
				this.account = user.account;
			}

			this.from = this.$route.query.from || '';
			let {games,payments} = await this.$getAppBaseData(this.from);
			this.games = games;	
			let canChosePayments = [];
			for (var i = 0; i < payments.length; i++) {
				var config = payments[i].configs;
				if(config){
					config = JSON.parse(config);
					if(config.is_test){
						if(!user) continue;
						if(!config.test_accounts) continue;
						if(config.test_accounts.indexOf(user.account)<0) continue;
					}
				} 
				canChosePayments.push(payments[i]);
			}
			this.payments = canChosePayments;
			this.choseFirstPayment();	
		},
		mounted(){
			this.getPayResult();
		}
	}
</script>
<style scoped>
.payments{
	height: 60px;
	border-bottom: 1px solid #dedede;
	padding-left: 20px;
}
.payments a{
	float: left;
	height: 60px;
	box-sizing: border-box;
	padding:20px 30px;
}
.payments a.active{
	border-bottom: 3px solid #c72729
}
.payments a img{
	height: 20px;
}
.charge-container{
	margin-top: 50px;
	margin-left: 30px;
	border-left: 1px solid #eee;
}
.step-div{
	position: relative;
	padding-left: 20px;
	padding-bottom: 30px;
}
.step-div .step-num{
	position: absolute;
	width: 20px;
	height: 20px;
	text-align: center;
	line-height: 20px;
	background-color: #ddd;
	font-size: 12px;
	border-radius: 50%;
	left: -10px;
	top: 0px
}
.step-div>b{
	display: block;
	margin-bottom: 15px;
	color: #444;
	font-weight: normal;
	font-size: 14px;
}
.game-region select{
	margin-right: 10px;
	background-color: #dedede;
	border: none;
	height: 30px;
}
.amount-div span{
	display: inline-block;
	padding: 0 15px;
	min-width: 120px;
	height: 40px;
	line-height: 40px;
	font-size: 18px;
	font-weight: bold;
	background-color: #dedede;
	margin-right: 10px;
	margin-bottom: 10px;
	border-radius: 5px;
	text-align: center;
	cursor: pointer;
	border: 3px solid #dedede
}
.amount-div span.active,.bank-div a.active{
	background-image: url(../assets/chosed.png);
	background-repeat: no-repeat;
	background-position: right bottom;
	-webkit-background-size: 18px auto;
	background-size: 18px auto;
	border: 3px solid #c72729
}
.amount-div span input{
	background-color: #dedede;
	border:none;
	outline: none;
	width: 120px;
	text-align: center;
	font-size: 18px;
	font-weight: bold;
}
.bank-div a{
	display: inline-block;
	height: 40px;
	line-height: 40px;
	margin-right: 10px;
	margin-bottom: 10px;
	border: 1px solid #dedede;
	padding: 10px;
}
.bank-div a img{
	height: 40px;
}

table{
	width: 80%;
}
table th{
	background-color: #f2f2f2;
	height: 40px;
	border: 1px solid #dedede;
}
table td{
	height: 40px;
	border: 1px solid #dedede;
	text-align: center;
}

#charge-result{
	width: 500px;
	margin: 0px auto
}

#charge-result h2{
	background-image: url(../assets/success.png);
	height: 40px;
	background-repeat: no-repeat;
	-webkit-background-size: auto 40px;
	background-size: auto 40px;
	padding-left: 50px;
	line-height: 40px;
	color: #c72729;
}
#charge-result b{
	display: block;
	border-bottom: 3px solid #c72729;
	font-size: 18px;
	text-align: center;
	line-height: 50px;
	margin-bottom: 10px;
}
#charge-result span{
	display: block;
	height: 34px;
	line-height: 34px;
	font-size: 16px;
	color: #444;
}
#charge-result span i{
	margin-right: 15px;
	color: #999
}

.confirm-btn{
	display: inline-block;
	background-color: #c72729;
	color: #fff;
	padding: 10px 25px;
	border-radius: 3px;
}
</style>